import React, {useEffect, useContext, useMemo} from 'react';
import { Box, Button, Stack, TableCell, TextField, MenuItem, Typography, IconButton, Dialog, Backdrop, CircularProgress } from '@mui/material';
import {Context} from '../App';
import {API} from '../conf';
import SorTableCheckable from '../Components/ui/sortable-checkable';
import { Add, DeleteForever, Edit, InfoOutlined } from '@mui/icons-material';
import Header from '../Components/ui/Header';
import ProjectForm from '../Components/forms/project';
import moment from 'moment';

export default function Billets() {
    const {updateConnect, region} = useContext(Context)
    const [load, setLoad] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [action, setAction] = React.useState('');
    const [projects, setProjects] = React.useState([]);
    const [projectId, setProjectId] = React.useState('');
    const [billets, setBillets] = React.useState([]);
    const [billet, setBillet] = React.useState();
    const [selectItems, setItems] = React.useState([]);
    const [searchInput, setSearchInput] = React.useState('');

    const projet = useMemo(()=>projects.find(p=>p._id===projectId), [projectId, projects]);

    const table = [
        {header: "N°", sortable: true, sortBy:(el)=>el.titre.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'50px'}}>{row.titre}</TableCell>},
        {header: "Participant", sortable: true, sortBy:(el)=>el.description.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'200px'}}>{row.statut}</TableCell>},
        {header: "Coordonnées participant", sortable: true, sortBy:(el)=>el.type, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'200px'}}>{row.type}</TableCell>},
        {header: "Status", sortable: true, sortBy:(el)=>new Date(el.dateDebut).getTime(), row: (row, index)=><TableCell key={index} sx={{minWidth:'200px', textAlign:'center'}}>{moment(row.dateDebut).format('DD/MM/yyy')+' - '+moment(row.dateFin).format('DD/MM/yyyy')}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'180px', textAlign:'end'}} >
            <IconButton aria-label="informations complémentaires" onClick={()=>{setBillet(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" onClick={()=>{setBillet(row); manage_dialog(true, 'delete')}}><DeleteForever fontSize="small"/></IconButton>
            <IconButton aria-label="modifier" onClick={()=>{setBillet(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.titre+' '+item.description+' '+item.organisateur
    }

    function searchFilter(a, b) {
        return normalize(get_searchable(a)).includes(normalize(b))
    }

    function manage_dialog(status, action='') {
        setOpen(status)
        setAction(action)
        if(!status) {
            setBillet()
        }
    }

    async function showResult(result) {
        manage_dialog(true, result ? 'success' : 'echec')
        await new Promise(resolve => setTimeout(resolve, 3000))
        manage_dialog(false)
    }

    useEffect(() => {
        const query = new URLSearchParams({region, type:'évènement'}).toString();

        fetch(API.concat('/projects?'+query), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                updateConnect(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setProjects(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching projects:", error);
        }).finally(() => {
            setLoad(false);
        });
    }, []);

    return(
        <Box display='flex' flexDirection='column' flex={1} >
            <Header/>
            <Box flex={1} display='flex' flexDirection='column' sx={{padding:2}}>
                <Typography variant='h4' marginBlock={3} align='center'>
                    Gestionnaire billetterie
                </Typography>

                <TextField select label='Évènement' value={projectId} onChange={(e) => setProjectId(e.target.value)} fullWidth sx={{minWidth:'200px', marginBottom:2}}>
                    {projects.map((p, index) => (
                        <MenuItem key={index} value={p._id}>{p.titre}</MenuItem>
                    ))}
                </TextField>

                <Stack direction="row" spacing={2} marginBottom={1.5} alignItems='center' justifyContent={'space-between'}>
                    <TextField value={searchInput} onChange={(e)=>setSearchInput(e.target.value)} label="Rechercher un billet..." variant="outlined" size="small" sx={{width:'60%'}}/>
                    {/* <Button variant="contained" color="primary" onClick={()=>manage_dialog(true, 'add')} startIcon={<Add/>}>
                        Nouveau
                    </Button> */}
                </Stack>

                <SorTableCheckable {...{data:billets.filter(reg=>searchFilter(reg, searchInput)),table, selectItems, setItems, rowsPerPage:25, rowsPerPageOptions:[25,50,100]}}/>
            </Box>

            <Dialog {...{open, onClose:()=>manage_dialog(false), maxWidth:'md', fullWidth:true}}>
                {action === 'add' && <ProjectForm {...{close:()=>manage_dialog(false), showResult, setProjects}}/>}
                {action === 'edit' && <ProjectForm {...{close:()=>manage_dialog(false), showResult, setProjects, billet}}/>}
            </Dialog>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}

